<template>
  <div
    id="picnic_team_app"
    :class="{ 'ps--is-touch-device': isTouchDevice }"
    class="ps-z-max ps-fixed ps-left-0 ps-bottom-0 ps-w-full ps-h-full ps-pointer-events-none"
  >
    <detect-touch @touch-detected="assignTouch(true)" />
    <div
      v-if="routerMatches('ROUTE_LOGIN')"
      class="absolute w-full left-0 bottom-0"
    >
      <a
        href="#"
        @click.prevent="routerTo('ROUTE_LOGIN_FORM')"
        :class="[
          {
            'ps-opacity-25 hover:ps-opacity-100': routerMatchesExact(
              'ROUTE_LOGIN'
            ),
            'ps-opacity-0 pointer-events-none ': routerMatchesExact(
              'ROUTE_LOGIN_FORM'
            )
          }
        ]"
        class="block ps-mb-16 mx-auto ps-pointer-events-auto  hover:ps-bg-brand-orange ps-shadow-xl ps-w-10 ps-h-10 ps-rounded-full ps-bg-brand-brown-200  transition-opacity duration-500 ease-in-out"
        title="Login to Picnic"
      >
      </a>
    </div>
    <login-strategy
      :class="{
        'ps-is-active': routerMatchesExact('ROUTE_LOGIN_FORM')
      }"
      :login-message="loginMessage"
      :version="version"
    />

    <component
      v-if="currentUser && currentUser.id"
      :is="appMode"
      :launch-card="launchCard"
    />

    <app-toaster class="" />
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapActions,
  mapState
} from '@picnic-software/vuex'
import DetectTouch from '@/components/util/DetectTouch'
import AppHelp from '@/views/AppHelp'
import LoginStrategy from '@/views/LoginStrategy'
import AppToaster from '@/views/AppToaster'
import AppModeSite from '@/views/AppModeSite'
import DomHighlight from '@/components/DomHighlight'
import packageJSON from './../package.json'
import customServiceModuleTemplate from '@/store/modules/provider/custom_service'
import { APP_IS_TOUCH_DEVICE } from '@/store/mutation-types'
import {
  ROUTE_LOGIN,
  ROUTE_LOGIN_FORM,
  ROUTE_CONTROLS,
  ROUTE_CARD,
  ROUTE_CARD_COMMENTS,
  ROUTE_LIST,
  ROUTE_LIST_PAGE,
  ROUTE_LIST_PROJECT,
  ROUTE_ME,
  ROUTE_HELP
} from '@/common/constants'
import { providerService } from '@/api'
import '@/icons/picnic-logo'
import '@/icons/close'

export default {
  name: 'picnic_team_app',
  props: {
    site: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: 'site'
    }
  },
  components: {
    AppModeSite,
    DetectTouch,
    LoginStrategy,
    DomHighlight,
    AppToaster,
    AppHelp
  },
  data() {
    return {
      loginMessage: null,
      token: null
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.auth.user,
      isTouchDevice: state => state.app.isTouchDevice
    }),
    ...mapGetters({
      routerMatches: 'router/matches',
      routerMatchesExact: 'router/matchesExact',
      isModeSite: 'app/isModeSite'
    }),
    appMode() {
      if (this.mode === 'project') {
        return 'AppModeSpace'
      }
      return 'AppModeSite'
    },
    version() {
      return packageJSON.version
    }
  },
  async created() {
    console.info(`Picnic Version: ${this.version}`)
    this.processUrl()

    const customServices = await this.bootstrap(this.site)
    if (!customServices) return
    this.assignCustomServices(customServices)
    this.auth()
  },
  methods: {
    ...mapMutations({
      routerTo: 'router/to',
      assignTouch: 'app/isTouchDevice'
    }),
    ...mapActions({
      bootstrap: 'app/bootstrap',
      addCustomService: 'provider/addCustomService',
      routerCard: 'router/card',
      assignToken: 'auth/token',
      authenticate: 'auth/authenticate'
    }),

    assignCustomServices(customServices) {
      customServices.forEach(cs => this.createCustomServiceStore(cs))
    },

    createCustomServiceStore(cs) {
      const customStore = this.$cloneDeep(customServiceModuleTemplate)
      customStore.state.name = cs.name
      this.$store.registerModule(['provider', cs.name], customStore)
      this.addCustomService(cs.name)
    },

    async auth() {
      // Check for token from redirect
      try {
        await this.assignToken(
          this.token || localStorage.getItem('picnic-team-jwt')
        )
        await this.authenticate()
      } catch (error) {
        console.error(error)
        console.warn('401: Picnic login required')
        this.showLogin()
      }
    },

    processUrl() {
      const url = new URL(window.location)
      this.launchCard = url.searchParams.get('picnic_team_card')
      this.token = url.searchParams.get('picnic_team_token')

      // Remove params
      url.searchParams.delete('picnic_team_card')
      url.searchParams.delete('picnic_team_token')

      // Replace URL
      if (history.pushState) {
        history.pushState({ path: url.toString() }, '', url.toString())
      }
    },

    showLogin(error) {
      if (this.launchCard) {
        this.loginMessage = 'Login to view card details'
      }
      this.routerTo(ROUTE_LOGIN)
    }
  }
}
</script>
